
export class DashboardSite {
  name: string;
  id: string;
  hasInduction: boolean;
  countWorkerUsers: number;
  countValidInductions: number;
  countInvalidInductions: number;
  countExpiredCompetencies: number;
  countAssets: number;
  countLockedAssets: number;
  countUnlockedAssets: number;
  countExpiredCertificates: number;
  countSurrendered: number;

  public deserialize(input: any): this {
    this.id = input.siteId;
    this.name = input.siteName;
    this.hasInduction = input.hasInduction;
    this.countWorkerUsers = input.countWorkerUsers;
    this.countValidInductions = input.countValidInductions;
    this.countInvalidInductions = input.countInvalidInductions;
    this.countExpiredCompetencies = input.countExpiredCompetencies;
    this.countAssets = input.countAssets;
    this.countLockedAssets = input.countLockedAssets;
    this.countUnlockedAssets = input.countUnlockedAssets;
    this.countExpiredCertificates = input.countExpiredCertificates;
    this.countSurrendered = input.countSurrendered;

    return this;
  }

  public clone(): DashboardSite {
    return Object.assign(new DashboardSite(), this);
  }
};
